import type { Curator, CuratorsFromMany, CuratorsResponse, CuratorType } from '../types';

export function mapManyDataToIU(data: CuratorsFromMany): CuratorsResponse {
  return {
    curators: data.data.map((curator) => ({
      id: curator.id,
      slug: curator?.slug || null,
      name: `${curator.first_name} ${curator.last_name}`,
      position: curator.position,
      photo: curator.photo,
      reviewsCount: curator.reviews_count,
    })),
    totalCount: data.total_count,
  };
}

export function mapDataToIU(data: Curator): CuratorType {
  return {
    id: data.id,
    slug: data.slug,
    // name: data.name,
    position: data.position,
    biography: data.biography,
    firstName: data.first_name,
    lastName: data.last_name,
    // verified: data.verified,
    // biography: data.biography,
    socialProfiles: data.social_profiles,
    photo: data.photo,
    photoAttribution: data.photo_attribution,
    // photoAttribution: data.photo_attribution,
    // institutions: data.institutions,
    // styles: data.styles,
    // fields: data.medium,
    // countries: data.locations,
    // dateOfBirth: data.date_of_birth,
    // dateOfDeath: data.date_of_death,
  };
}
